import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  outlets: [],
};

const getters = {
  allOutlets: (state) => state.outlets,
};

const actions = {
  async fetchOutlets({ commit }, params = {}) {
    try {
      commit("resetOutlets");
      const response = await axios.get("/outlet", { params: prm(params) });
      commit("setOutlets", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outlets:", error);
    }
  },
  async createOutlet({ commit }, outlet) {
    try {
      const response = await axios.post("/outlet", outlet);
      commit("addOutlet", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create outlet:", error);
      throw error;
    }
  },
  async fetchOutletById(_, id) {
    try {
      const response = await axios.get(`/outlet/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch outlet:", error);
      throw error;
    }
  },
  async updateOutlet({ commit }, outlet) {
    try {
      const response = await axios.put(`/outlet/${outlet.id}`, outlet);
      commit("updateOutlet", response.data);
    } catch (error) {
      console.error("Failed to update outlet:", error);
      throw error;
    }
  },
  async deleteOutletById({ commit }, id) {
    try {
      const response = await axios.delete(`/outlet/${id}`);
      commit("removeOutlet", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete outlet:", error);
      throw error;
    }
  },
};

const mutations = {
  setOutlets(state, outlets) {
    state.outlets = outlets.data; // Ensure this matches your API's response structure
  },
  addOutlet(state, outlet) {
    state.outlets.push(outlet);
  },
  updateOutlet(state, updatedOutlet) {
    const index = state.outlets.findIndex(
      (outlet) => outlet.id === updatedOutlet.id
    );
    if (index !== -1) {
      state.outlets.splice(index, 1, updatedOutlet);
    }
  },
  removeOutlet(state, id) {
    state.outlets = state.outlets.filter(
      (outlet) => outlet.id !== id
    );
  },
  resetOutlets(state) {
    state.outlets = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
